
import { Autocomplete, Box, Button, Checkbox, Chip, CircularProgress, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, OutlinedInput, Select, TextField, Typography } from '@mui/material'
import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react'
import apiUrl from '../../Config';
import { useLocation, useNavigate } from 'react-router-dom';
import Context from '../../context/Context';
import { toast } from 'react-toastify';
import { Cross, DeleteIcon, Trash2, X } from 'lucide-react';
import { Doughnut } from 'react-chartjs-2';

const AddEditTechnicain = () => {
  const { services, getServices, packageServices, getPackageServices } = useContext(Context);
  const location = useLocation();
  const technician = location?.state?.techinicianId;

  const isEdit = Boolean(technician);


  const navigate = useNavigate();
  const fileInputRef = useRef(null);

  const [form, setForm] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    latitude: '',
    longitude: '',
    technicianType: 'freelance',
    profileImage: null,
    commissionPercentage: '',
    isActive: true,
    isOnline: false,
    experienceLevel: "",
    registeredFrom: "admin",
    isVerified: false,
    isDeleted: false
  });

  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedPackageServices, setSelectedPackageServices] = useState([])

  const [documents, setDocuments] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [previewUrl, setPreviewUrl] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  // const technicianTypes = ['freelance', 'franchise'];
  const documentTypes = ['aadhar', 'idProof', 'certification', 'policeVerification'];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    setValidationErrors(prev => ({ ...prev, [name]: '' }));
    setError('');
  };


  // const handleDocumentChange = (type, file) => {
  //   if (!file) return;
  //   const newDoc = {
  //     type,
  //     file,
  //     url: URL.createObjectURL(file),
  //   };
  //   setDocuments(prev => {
  //     const filtered = prev.filter(d => d.type !== type);
  //     return [...filtered, newDoc];
  //   });
  // };



  const handleDocumentChange = (docType, file) => {
    const updatedDocs = [...documents];
    const existingIndex = updatedDocs.findIndex(doc => doc.type === docType);

    const url = URL.createObjectURL(file);
    const fileName = file.name;

    const newDoc = { type: docType, file, url, fileName };

    if (existingIndex > -1) {
      updatedDocs[existingIndex] = { ...updatedDocs[existingIndex], ...newDoc };
    } else {
      updatedDocs.push(newDoc);
    }

    setDocuments(updatedDocs);
  };



  const handleServiceSelect = (e, newValue) => {
    setSelectedServices(newValue);
    setValidationErrors(prev => ({ ...prev, services: '' }));

  };

  const handlePackageServiceSelect = (e, newValue) => {
    setSelectedPackageServices(newValue);
    setValidationErrors(prev => ({ ...prev, services: '' }));

  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setForm(prev => ({ ...prev, profileImage: file }));
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const validateForm = () => {
    const errors = {};
    if (!form.firstName.trim()) errors.firstName = 'First name is required';
    if (!form.lastName.trim()) errors.lastName = 'Last name is required';
    if (!form.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      errors.email = 'Invalid email format';
    }
    if (!form.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^\d{10}$/.test(form.phone)) {
      errors.phone = 'Phone number must be 10 digits';
    }
    // if (!form.address.trim()) errors.address = 'Address is required';
    if (!form.latitude.trim()) errors.latitude = 'Latitude is required';
    if (!form.longitude.trim()) errors.longitude = 'Longitude is required';
    if (!form.technicianType) errors.technicianType = 'Technician type is required';
    if (!form.commissionPercentage) errors.commissionPercentage = 'Commission Percentage  is required';
    if (selectedServices.length === 0) errors.services = 'At least one service must be selected';
    if (selectedPackageServices.length === 0) errors.selectedPackageServices = 'At least one Package Services must be selected';
    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleDocumentDelete = async (docId, docType) => {
    try {

      setLoading(true);

      // Remove from local state
      setDocuments(prev => prev.filter(doc => doc.type !== docType));
      // If document is saved in DB (has an id), delete from backend
      if (docId) {
        const res = await axios.delete(`${apiUrl}/techniciandocument/deletedocument/${docId}`);
        if (res.data.status === true) {
          toast.success(res.data.message || 'Document deleted successfully');
        }
      }


    } catch (err) {
      setError(err?.response?.data?.message || 'Error deleting document');
    } finally {
      setLoading(false);
    }
  };

  const getTechnicianDetails = async () => {
    try {
      const response = await axios.get(`${apiUrl}/technician/technician/${technician}`);
      if (response.data.status === true) {
        const data = response.data.technician;
        setForm({
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          phone: data.phone,
          address: data.address || '',
          latitude: data.latitude || '',
          longitude: data.longitude || '',
          technicianType: data.technicianType || 'freelance',
          experienceLevel: data.experienceLevel || '',
          commissionPercentage: data.commissionPercentage || '',
          registeredFrom: data.registeredFrom || 'admin',
          profileImage: data.profileImage || null,
          // id: data.id,
          profileImage: data.profileImage || null,
          isActive: data.isActive,
          isOnline: data.isOnline,
          isVerified: data.isVerified,
          isDeleted: data.isDeleted
        });

        const currentServiceIds = Array.isArray(data.skillServices)
          ? data.skillServices.map(s => ({
            serviceId: s.serviceId,
            id: s.id,
            name: s.service?.name || ''
          }))
          : [];

        setSelectedServices(currentServiceIds);


        const currentPackageServiceIds = Array.isArray(data.skillPackageServices)
          ? data.skillPackageServices.map(s => ({
            serviceId: s.packageServiceId,
            id: s.id,
            name: s.packageService?.name || ''
          }))
          : [];
        setSelectedPackageServices(currentPackageServiceIds)

        // setExistingServices(data.skillServices || []);

        // const formattedDocs = (data.documents || []).map(doc => ({
        //   id: doc.id,
        //   type: doc.type,
        //   url: doc.url,
        // }));
        // setDocuments(formattedDocs);

        const formattedDocs = (data.documents || []).map(doc => ({
          id: doc.id,
          type: doc.documentName, // assuming `type` is stored in `documentName`
          url: doc.documentPath, // use the correct key
          fileName: doc.documentPath?.split('/').pop() || '' // extract filename from URL
        }));
        setDocuments(formattedDocs);

        if (data.profileImage) {
          setPreviewUrl(data.profileImage);
        }
      }
    } catch (error) {

      setError(error?.response?.data?.message || "Error fetching technician details");
    }
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      if (!validateForm()) return;
      setError('');

      const formData = new FormData();

      // Append basic form fields (excluding profileImage for separate handling)
      Object.entries(form).forEach(([key, value]) => {
        if (value !== null && key !== 'profileImage') {
          formData.append(key, value);
        }
      });

      // If editing, include the ID
      if (isEdit && form.id) {
        formData.append('id', form.id);
      }

      // Documents handling
      const documentsMeta = [];

      documents.forEach(doc => {
        if (doc.file instanceof File) {
          formData.append("documents", doc.file); // Actual file


          documentsMeta.push({
            type: doc.type,
            ...(doc.id ? { id: doc.id } : {}) // Include ID if it's an update
          });
        }
      });

      formData.append("documentsMeta", JSON.stringify(documentsMeta));
      // Services handling
      selectedServices.forEach((id, index) => {
        formData.append(`services[${index}][serviceId]`, id.serviceId
        );
      });
      selectedPackageServices.forEach((id, index) => {
        formData.append(`packageService[${index}][serviceId]`, id.serviceId
        );
      });

      // Profile image handling
      if (form.profileImage instanceof File) {
        formData.append('profileImage', form.profileImage);
      } else if (typeof form.profileImage === 'string' && !form.profileImage.startsWith('blob:')) {
        // Optionally append the existing image URL if backend supports it
        formData.append('profileImage', form.profileImage);
      }

      // API request
      let response;
      if (isEdit) {
        response = await axios.put(`${apiUrl}/technician/profileupdate/${technician}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      } else {
        response = await axios.post(`${apiUrl}/technician/create`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }

      if (response.data.status === true) {
        toast.success(response.data.message || "Technician saved successfully");
        navigate(-1); // Go back to previous page
      } else {
        setError(response.data.message || "Unknown error");
      }

    } catch (error) {
      const errorData = error?.response?.data;
      const firstFieldError = errorData?.errors?.[0]?.msg;

      setError(firstFieldError || errorData?.message || 'Submission error occurred.');
    } finally {
      setLoading(false);
    }
  };

  const handleServiceDelete = async (serviceToDelete) => {
    if (!serviceToDelete.id) {
      // No backend id, just remove locally
      setSelectedServices(prev => prev.filter(s => s.serviceId !== serviceToDelete.serviceId));
      return;
    }

    try {
      setLoading(true);
      const response = await axios.delete(`${apiUrl}/skills/deleteservice/${serviceToDelete.id}`);
      if (response?.data?.status === true) {
        toast.success(response?.data?.message || "Service deleted successfully");
        setSelectedServices(prev => prev.filter(s => s.serviceId !== serviceToDelete.serviceId));
      } else {
        setError(response?.data?.message || "Failed to delete service");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error deleting service");
    } finally {
      setLoading(false);
    }
  };

  const handlePackageServiceDelete = async (packageserviceToDelete) => {
    if (!packageserviceToDelete.id) {
      // No backend id, just remove locally
      setSelectedPackageServices(prev => prev.filter(s => s.serviceId !== packageserviceToDelete.serviceId));
      return;
    }

    try {
      setLoading(true);
      const response = await axios.delete(`${apiUrl}/skills/deletepackageservice/${packageserviceToDelete.id}`);
      if (response?.data?.status === true) {
        toast.success(response?.data?.message || " Package Service deleted successfully");
        setSelectedPackageServices(prev => prev.filter(s => s.serviceId !== packageserviceToDelete.serviceId));
      } else {
        setError(response?.data?.message || "Failed to delete service");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error deleting service");
    } finally {
      setLoading(false);
    }
  };


  const options = services.map(service => {
    const existing = selectedServices.find(s => s.serviceId === service.id);
    return existing ? existing : { id: null, serviceId: service.id, name: service.name };
  });

  const packageoptions = packageServices.map(service => {
    const existing = selectedPackageServices.find(s => s.serviceId === service.id);
    return existing ? existing : { id: null, serviceId: service.id, name: service.name };
  });


  useEffect(() => {
    getServices();
    getPackageServices()
  }, []);

  useEffect(() => {
    if (isEdit) {
      getTechnicianDetails();
    }
  }, []);

  useEffect(() => {
    if (form.profileImage instanceof File) {
      const url = URL.createObjectURL(form.profileImage);
      setPreviewUrl(url);
      return () => URL.revokeObjectURL(url);
    } else if (typeof form.profileImage === 'string') {
      setPreviewUrl(form.profileImage);
    }
  }, [form.profileImage]);
  return (
    <>
      <Box sx={{ p: { xs: 2, sm: 3 } }}>
        <Typography variant="h4" fontWeight={400} mb={1} >
          {technician ? `Edit Technician ` : 'Add New Technician'}

        </Typography>
        <Divider sx={{}} />

        <Grid container spacing={2} sx={{ mt: 2 }}>
          <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
            <TextField fullWidth label="First Name" size='small' name="firstName" value={form.firstName} onChange={handleChange} error={!!validationErrors.firstName} helperText={validationErrors.firstName} />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
            <TextField fullWidth label="Last Name" size='small' name="lastName" value={form.lastName} onChange={handleChange} error={!!validationErrors.lastName} helperText={validationErrors.lastName} />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
            <TextField fullWidth label="Email" size='small' name="email" value={form.email} onChange={handleChange} error={!!validationErrors.email} helperText={validationErrors.email} />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
            <TextField fullWidth label="Phone" size='small' name="phone" type='number' value={form.phone} onChange={handleChange} error={!!validationErrors.phone} helperText={validationErrors.phone} />
          </Grid>

          <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
            <TextField fullWidth label="Latitude" size='small' name="latitude" value={form.latitude} onChange={handleChange} error={!!validationErrors.latitude} helperText={validationErrors.latitude} />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
            <TextField fullWidth label="Longitude" size='small' name="longitude" value={form.longitude} onChange={handleChange} error={!!validationErrors.longitude} helperText={validationErrors.longitude} />
          </Grid>
          <Typography variant="body2">
            You should enter latitude for store listing. You can fetch location coordinates from{' '}
            <a href="https://www.latlong.net" target="_blank" rel="noopener noreferrer">
              https://www.latlong.net
            </a>.
          </Typography>

          <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
            <TextField fullWidth label="Commission Percentage" size='small' name="commissionPercentage" value={form.commissionPercentage} onChange={handleChange} error={!!validationErrors.commissionPercentage} helperText={validationErrors.commissionPercentage} />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 6 }}>
            <TextField fullWidth label="Address" size='small' name="address" value={form.address} onChange={handleChange} />
          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 6 }}>

            <Autocomplete
              size='small'
              multiple
              options={options}
              getOptionLabel={(option) => option.name}
              value={selectedServices}
              onChange={handleServiceSelect}
              filterSelectedOptions
              disableCloseOnSelect
              isOptionEqualToValue={(option, value) => option.serviceId === value.serviceId}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    label={option.name}
                    {...getTagProps({ index })}
                    key={option.serviceId}
                    onDelete={() => handleServiceDelete(option)}
                    deleteIcon={<Trash2 size={16} />}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Select Services"
                  placeholder="Select multiple services"
                />
              )}
            />

            {validationErrors.services && (
              <Typography color="error" variant="caption">
                {validationErrors.services}
              </Typography>
            )}

          </Grid>
          <Grid item size={{ xs: 12, sm: 6, md: 6 }}>

            <Autocomplete
              size='small'
              multiple
              options={packageoptions}
              getOptionLabel={(option) => option.name}
              value={selectedPackageServices}
              onChange={handlePackageServiceSelect}
              filterSelectedOptions
              disableCloseOnSelect
              isOptionEqualToValue={(option, value) => option.serviceId === value.serviceId}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                  <Chip
                    label={option.name}
                    {...getTagProps({ index })}
                    key={option.serviceId}
                    onDelete={() => handlePackageServiceDelete(option)}
                    deleteIcon={<Trash2 size={16} />}
                  />
                ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  label="Select Package servicec"
                  placeholder="Select multiple services"
                />
              )}
            />

            {validationErrors.selectedPackageServices && (
              <Typography color="error" variant="caption">
                {validationErrors.selectedPackageServices}
              </Typography>
            )}

          </Grid>


          <Grid item size={12}>
            <FormControlLabel control={<Checkbox checked={form.isActive} onChange={handleChange} name="isActive" />} label="Active" />
            <FormControlLabel control={<Checkbox checked={form.isOnline} onChange={handleChange} name="isOnline" />} label="Online" />
            <FormControlLabel control={<Checkbox checked={form.isVerified} onChange={handleChange} name="isVerified" />} label="Verified" />
            <FormControlLabel control={<Checkbox checked={form.isDeleted} onChange={handleChange} name="isDeleted" />} label="Deleted" />
          </Grid>

          {documentTypes.map((docType) => {
            const doc = documents.find(d => d.type === docType);

            return (
              <Grid item size={{ xs: 12, sm: 3, md: 3 }} key={docType}>
                <Typography variant="subtitle2">{docType.toUpperCase()}</Typography>

                {/* Hidden File Input */}
                <input
                  type="file"
                  id={`doc-input-${docType}`}
                  accept="image/*,application/pdf"  // accept images and pdf
                  style={{ display: 'none' }}
                  onChange={(e) => handleDocumentChange(docType, e.target.files[0])}
                />

                {/* Show preview and delete if file is present */}
                {doc?.url || doc?.fileName ? (
                  <Box mt={1}>
                    {doc.url?.toLowerCase().endsWith('.pdf') || doc.fileName?.toLowerCase().endsWith('.pdf') ? (
                      <>
                      {/* <Typography>{doc.fileName}</Typography> */}
                       <iframe
                        src={doc.url}
                        alt={docType}
                        style={{ width: '100px', height: '100px', objectFit: 'contain' }}
                      />
                      </>
                    ) : (
                      <img
                        src={doc.url}
                        alt={docType}
                        style={{ width: '100px', height: '100px', objectFit: 'contain' }}
                      />
                    )}
                    <Box mt={"auto"}>
                      <Button
                        color="error"
                        size="small"
                        startIcon={<Trash2 size={16} />}
                        onClick={() => handleDocumentDelete(doc.id, docType)}
                      >
                        Delete
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <Button
                    variant="outlined"
                    onClick={() => document.getElementById(`doc-input-${docType}`).click()}
                    sx={{ mt: 1 }}
                  >
                    Upload File
                  </Button>
                )}

              </Grid>
            );
          })}



          <Grid item size={12}>
            <Typography variant="h6">Profile Image</Typography>
            {previewUrl && (
              <Grid item size={12}>
                <Box mt={1}>
                  <img src={previewUrl} alt="Preview" style={{ width: '100px', height: '100px' }} />
                </Box>
              </Grid>
            )}

            <Button variant="outlined" onClick={handleUploadClick}>
              {form.profileImage ? 'Change Profile Image' : 'Upload Profile Image'}
            </Button>
            <input
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              ref={fileInputRef}
              onChange={handleFileChange}
            />

          </Grid>


          {error && (
            <Grid item size={12}>
              <Typography color="error">{error}</Typography>
            </Grid>
          )}


          <Grid item size={12}>
            <Box display="flex" justifyContent="end" mt={2} gap={2}>
              <Button variant="outlined" color="primary" onClick={() => navigate(-1)}>
                Cancel
              </Button>
              <Button
                variant="contained"
                disabled={loading}
                onClick={handleSubmit}
              >
                {loading ? (
                  <CircularProgress size={24} sx={{ color: '#fff' }} />
                ) : (
                  isEdit ? 'Update' : 'Create'
                )}
              </Button>

            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default AddEditTechnicain
